/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import { WishListIconComponent } from '@msdyn365-commerce/components';
import { getTelemetryObject } from '@msdyn365-commerce-modules/utilities';
import classnames from 'classnames';
import * as React from 'react';

import { ICusWishlistIconData } from './cus-wishlist-icon.data';
import { ICusWishlistIconProps } from './cus-wishlist-icon.props.autogenerated';

/**
 * CusWishlistIcon module.
 * Self-contained header wishlist action: owns the wishlist data action, item count,
 * and navigation behavior of the standard WishListIconComponent.
 */
const CusWishlistIcon = (props: ICusWishlistIconProps<ICusWishlistIconData>): JSX.Element => {
    const { config, context, data, id, resources, typeName } = props;

    const telemetryContent = getTelemetryObject(context.request.telemetryPageName ?? '', props.friendlyName, props.telemetry);

    const wishlistCount = data.wishlists?.result?.[0]?.CommerceListLines?.length ?? 0;


    const disableTooltip: boolean = context.app.config.disableTooltip || false;

    return (
        <WishListIconComponent
            className={classnames('cus-wishlist-icon', { active: wishlistCount > 0 })}
            showButtonTooltip={!disableTooltip}
            wishlistTooltipText={resources.wishlistTooltipText}
            context={context}
            id={id}
            typeName={typeName}
            telemetryContent={telemetryContent}
            data={{}}
            wishlistCount={wishlistCount}
            wishlistCountLabel={resources.wishlistCountLabel}
            isDispayWishlistCount={config.shouldShowWishlistCount}
        />
    );
};

export default CusWishlistIcon;
